import React from 'react';

export default class System extends React.Component {
  getCurrentClass = () => {
    let classes = '';

    if (this.props.isPrintable) classes += ' invisible';
    if (this.props.isActive) classes += ' active';

    return classes;
  };

  getSystemName = index => {
    const {boatSystems, system, allSystemsList} = this.props;

    if (!allSystemsList.length) return '';

    const fullName = allSystemsList.find(sys => sys.id === system.componentSystemId).name;
    let systemName = fullName.split('(')[0].trim();
    let sameTypeSystems = 0;
    let systemOrder = 1;
    boatSystems.forEach((otherSystem, otherIndex) => {
      if (otherSystem.componentSystemId === system.componentSystemId) {
        sameTypeSystems++;
        if (otherIndex < index) systemOrder++;
      }
    });
    if (sameTypeSystems !== 1) systemName = systemName + ` (${systemOrder})`;

    return systemName;
  };

  handleSystemChoose = key => () => {
    const {handleSystemChoose, currentSystemIndex} = this.props;
    if (key !== currentSystemIndex) handleSystemChoose(key);
    else handleSystemChoose(-1);
  };

  render() {
    const {indexKey, system} = this.props;
    const name = this.getSystemName();

    return (
      <div
        className={`boat-systems-scene__banner ${this.getCurrentClass()}`}
        onClick={this.handleSystemChoose(indexKey)}
      >
        <div className={`boat-systems-scene__banner-icon boat-systems-scene__banner-icon_type_${system.componentSystemId}`} />
        <div className='boat-systems-scene__banner-text'>{name}</div>
        <div className='boat-systems-scene__banner-valid-label' />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatSystems/System.jsx